<template lang="pug">
.block
  slot(v-if='$permission.has(...need)')
</template>

<script>
export default {
  name: 'block',
  props: {
    need: {
      default: undefined,
    },
  },
  computed: {
    needs() {
      if (!Array.isArray(this.need))
        return [this.need]
      return this.need
    },
  },
}
</script>




// WEBPACK FOOTER //
// Block.vue?cfda1270